import { type CardSize } from '@air/api/types';

/**
 * @TODO - Design team will provide the correct sizes for each card size
 */
export const FILE_CARD_SIZES: { [key in CardSize]: number } = {
  small: 196,
  medium: 196,
  large: 196,
  'extra-large': 196,
};

export const BOARD_CARD_SIZES: Record<CardSize, { height: number; width: number }> = {
  small: { height: 120, width: 220 },
  medium: { height: 120, width: 220 },
  large: { height: 164, width: 300 },
  'extra-large': { height: 164, width: 300 },
};
